<template>
  <div class="tags_div flex flex-wrap items-center gap-1.5">
    <template v-if="items.length === 0">
      <div class="text-xs secondary_color">
        <slot name="empty">
          {{ typeof emptyMessage === "string" ? emptyMessage : "" }}
        </slot>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item, index) in visibleItems"
        :key="index"
        class="selected_item_tag"
      >
        {{ item }}
      </div>
      <div
        v-if="remainingCount > 0"
        class="selected_item_tag cursor-pointer relative group"
      >
        +{{ remainingCount }}
        <div
          class="absolute left-0 bottom-full mb-2 hidden group-hover:block z-10 p-2 rounded bg-[var(--tooltip-bg)] text-xs whitespace-normal max-w-60 shadow-lg"
        >
          {{ remainingItems.join(", ") }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  items: string[];
  maxVisible?: number;
  emptyMessage?: string | object;
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  maxVisible: 3,
  emptyMessage: "No items",
});

const visibleItems = computed(() => {
  return props.items.slice(0, props.maxVisible);
});

const remainingCount = computed(() => {
  return Math.max(0, props.items.length - props.maxVisible);
});

const remainingItems = computed(() => {
  return props.items.slice(props.maxVisible);
});
</script>

<style scoped>
.tags_div {
  justify-content: flex-start;
}
</style>
